import Cookies from "js-cookie";
const expires = 7;
// 生产环境支持多个域名访问Cookie
const getCookieDomain = () => {
  if (__CUSTOM_ENV__ !== "production") {
    return "";
  }

  // 获取当前域名（SSR 安全）
  const currentDomain =
    typeof window !== "undefined" && window.location
      ? window.location.hostname
      : "";

  if (!currentDomain) {
    return "";
  }

  // 如果是AWS域名，不设置domain让Cookie在当前域名下生效
  if (currentDomain.includes(".pages.dev")) {
    return "";
  }

  // 如果是sharkfoto.com域名，设置为.sharkfoto.com
  if (currentDomain.includes("sharkfoto.com")) {
    return ".sharkfoto.com";
  }

  // 默认不设置domain
  return "";
};

const domain = getCookieDomain();
const path = "/";

// ip
const userIPKey = "sharkfoto_userIp";
export const getUserIp = () => Cookies.get(userIPKey) || "";
export const setUserIp = (userIp) => {
  Cookies.set(userIPKey, userIp, { expires, domain, path });
};
export const removeUserIp = () => Cookies.remove(userIPKey);

// User
const tokenKey = "sharkfoto_token";
export const getToken = () => Cookies.get(tokenKey, { domain });
export const setToken = (token) =>
  Cookies.set(tokenKey, token, { expires, domain, path });
export const removeToken = () => Cookies.remove(tokenKey, { domain });

const userIdKey = "sharkfoto_userId";
export const getUserId = () => Cookies.get(userIdKey) || "";
export const setUserId = (userId) =>
  Cookies.set(userIdKey, userId, { expires, domain, path });
export const removeUserId = () => Cookies.remove(userIdKey);

const userInfoKey = "sharkfoto_userInfo";
export const getUserInfo = () => Cookies.get(userInfoKey);
export const setUserInfo = (userInfo) =>
  Cookies.set(userInfoKey, userInfo, { expires, domain, path });
export const removeUserInfo = () => Cookies.remove(userInfoKey);

// refferId
const refferIdKey = "sharkfoto_reffer_id";
export const getRefferId = () => Cookies.get(refferIdKey);
export const setRefferId = (refferId) =>
  Cookies.set(refferIdKey, refferId, { expires, domain, path });
export const removeRefferId = () => Cookies.remove(refferIdKey);

// cookieBanner
const cookieStatusKey = "sharkfoto_cookieStatus";
export const getCookieStatus = () => Cookies.get(cookieStatusKey);
export const setCookieStatus = (status) =>
  Cookies.set(cookieStatusKey, status, { expires, domain, path });
export const removeCookieStatus = () => Cookies.remove(cookieStatusKey);
